import React, { useState } from "react";
import dayjs from "dayjs";
import { v4 as uuid } from "uuid";
import { Typography } from "@mui/material";
import { AddLinkModalStyled } from "./add-link-modal.styles";
import TextInputField from "../../../../../../components/form-fields/text-input-field/text-input-field";
import { useAuth } from "../../../../../../context/AuthContext";

const AddLinkModal = ({ onClose, onSave }) => {
  const [link, setLink] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const { userDetails } = useAuth();
  const providedBy = userDetails?.fullName;

  const handleSave = async () => {
    if (!link) {
      alert("Missing Link");
      return;
    }

    try {
      setIsSaving(true);
      const newLink = {
        id: uuid(),
        linkedAsset: link,
        providedBy,
        dateAdded: dayjs().format("DD-MM-YY"),
      };
      await onSave(newLink);
    } catch (error) {
      console.error("Error saving link:", error);
    } finally {
      setIsSaving(false);
      onClose(); // Close the modal after saving
    }
  };

  const handleCancel = () => {
    setLink("");
    onClose(); // Close the modal when Cancel is clicked
  };

  return (
    <AddLinkModalStyled
      confirmBtnTitle="Save"
      closeBtnTitle="Cancel"
      isConfirming={isSaving}
      disableConfirmBtn={isSaving}
      onConfirm={handleSave}
      onClose={handleCancel}
    >
      <div className="body">
        <div className="heading">
          <Typography variant="body2">Project Assets</Typography>
          <Typography variant="h4">Add New Link</Typography>
        </div>
        <div className="form">
          <TextInputField
            label="Paste Link Below"
            fullWidth
            margin="normal"
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />
        </div>
      </div>
    </AddLinkModalStyled>
  );
};

export default AddLinkModal;
